document.addEventListener('turbo:load', function() {
  const trixEditors = document.querySelectorAll('trix-editor');
  trixEditors.forEach((editor) => {
    const newEditor = editor.cloneNode(true)
    editor.replaceWith(newEditor)
  })
})
